import { orderBy } from "lodash/collection";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";

export function sortByProperty({ list, property, sortDirection }) {
  return orderBy(list, [property], sortDirection === SortDirection.DESC ? ["desc"] : ["asc"]);
}
